<script setup lang="ts">
  import { useNotifications } from '@/shared/lib'
  import { EditorPageHeader } from '@/shared/ui/components'

  import { usePost } from '@/entities/news'

  import { NewsEditor } from '@/features/news'

  definePage({
    meta: {
      layout: 'baseNew',
      contentManagerRoute: true,
    },
  })

  const { t } = useI18n()

  const route = useRoute('/news/item=[id]/edit/')
  const router = useRouter()
  const { errorNotification } = useNotifications()

  const postId = computed(() => Number(route.params.id))
  const { data: item, isPending, error } = usePost(postId)

  const breadcrumbLabel = computed(() => {
    if (item.value?.title) {
      return item.value.title
    }
    return t('news_breadcrumb_edit')
  })

  useHead({
    title: () => t('news_edit_page_title'),
  })

  watch(error, async (queryError) => {
    if (!queryError) {
      return
    }

    const status = (queryError as { status?: number }).status

    if (status === 404) {
      errorNotification('news_item_not_found')
    } else {
      errorNotification('base_something_went_wrong')
    }

    await router.push({ name: '/news/[[page]]' })
  })
</script>

<template>
  <div class="wide-responsive flex w-full flex-col">
    <EditorPageHeader
      parent-route-name="/news/[[page]]"
      parent-label-key="navigation_item_news"
      :current-label="breadcrumbLabel"
      data-testid="news-editor-page-header"
    />
    <div
      v-if="isPending"
      class="flex min-h-40 items-center justify-center py-8"
      aria-live="polite"
      aria-busy="true"
    >
      <NSpin size="medium" />
    </div>
    <NewsEditor
      v-else-if="item"
      mode="edit"
      :item="item"
    />
  </div>
</template>
